// All times display in Central Time (Dallas-Fort Worth)
const TIMEZONE = 'America/Chicago';

/**
 * Parse a UTC timestamp from SQLite (which stores without 'Z' suffix)
 */
export function parseUTC(dateStr) {
  if (!dateStr) return null;
  if (!dateStr.endsWith('Z') && !dateStr.includes('+')) {
    return new Date(dateStr.replace(' ', 'T') + 'Z');
  }
  return new Date(dateStr);
}

/**
 * Format a date string as full date + time in Central Time.
 *
 * Pass any toLocaleString options object as the second argument to
 * override the default formatting. `timeZone` is always forced to
 * America/Chicago — callers shouldn't override it.
 *
 * e.g. formatDateTime(s) → "2/27/2026, 10:24 AM"
 * e.g. formatDateTime(s, { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' })
 *      → "Feb 27, 2026, 10:24 AM"
 */
export function formatDateTime(dateStr, options = null) {
  const d = parseUTC(dateStr);
  if (!d) return '';
  const opts = options ? { ...options, timeZone: TIMEZONE } : { timeZone: TIMEZONE };
  return d.toLocaleString('en-US', opts);
}

/**
 * Format a date string as date only in Central Time.
 * Accepts the same options pass-through as formatDateTime.
 */
export function formatDate(dateStr, options = null) {
  const d = parseUTC(dateStr);
  if (!d) return '';
  const opts = options ? { ...options, timeZone: TIMEZONE } : { timeZone: TIMEZONE };
  return d.toLocaleDateString('en-US', opts);
}

/**
 * Format a date string as time only in Central Time
 * e.g. "10:24 AM"
 */
export function formatTime(dateStr) {
  const d = parseUTC(dateStr);
  if (!d) return '';
  return d.toLocaleTimeString('en-US', { timeZone: TIMEZONE, hour: '2-digit', minute: '2-digit' });
}

/**
 * Format duration in minutes as human-readable string
 * e.g. 5 → "5m", 90 → "1h 30m", 0 → "< 1m"
 */
export function formatDuration(minutes) {
  if (minutes === null || minutes === undefined || minutes === '') return '\u2014';
  const m = parseInt(minutes);
  if (isNaN(m)) return '\u2014';
  if (m === 0) return '< 1m';
  if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60);
  const rem = m % 60;
  return rem > 0 ? `${h}h ${rem}m` : `${h}h`;
}
